import { type Epic } from '../models';
import RecordFilter from './RecordFilter';

class EpicFilter extends RecordFilter {
  matches(record: { epic: Epic }) {
    return super.matches(record.epic);
  }
}

export default EpicFilter;
